import React from 'react'
//hook for checking if an el is in viewport
import useIsInViewport from 'use-is-in-viewport'

function Welcome() {
	const [isInViewport, targetRef] = useIsInViewport()
	var classes = `${isInViewport ? "visible" : "hidden"}`
	return ( 
		<div ref={targetRef} className={classes}>
			<div className="Welcome" id="welcome">
				<h1>Joseph Guzzardo</h1> <br/>
				<h3>Full Stack Engineer coding in NYC.</h3>
			</div>
		</div>
	  )
}

export default Welcome